import { styled } from '@mui/system';
import { Box, Container } from '@mui/material';
import { Stack } from '@mui/system';

export const SectionContainer = styled(Container)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  justifyContent: 'space-between',
}));

export const ServicesStack = styled(Stack)(({ theme }) => ({
  gap: '20px',
  width: '100%',
  maxWidth: theme.breakpoints.values.lg,
  margin: '0 auto',
  [theme.breakpoints.down('lg')]: {
    padding: '0 16px',
  },
}));

export const CtaButtonContainer = styled(Box)(({ theme }) => ({
  margin: '0 auto',
  width: 'fit-content',
}));
